import React from 'react';
import { CardHeader, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { LinkProps } from 'react-router-dom';
import { GetCurrentVenueCustomPaymentMethodsQuery } from '../../../generated/graphql';
import { routePaths } from '../../../routePaths';
import { Card, CardHeaderTitle, PlainLink, Typography } from '../../../ui-kit';

type CustomPaymentMethodListViewProps = Pick<GetCurrentVenueCustomPaymentMethodsQuery, 'currentVenueCustomPaymentMethods'>;

const LinkWrapper: React.FC<Partial<Pick<LinkProps, 'to'>>> = ({ children, to }) => {
    if (to) {
        return <PlainLink to={to}>{children}</PlainLink>;
    }

    return <div>{children}</div>;
};

const CustomPaymentMethodListView = ({ currentVenueCustomPaymentMethods }: CustomPaymentMethodListViewProps) => {
    const { t } = useTranslation();
    return (
        <Grid container spacing={3} alignItems='stretch'>
            {currentVenueCustomPaymentMethods.map(({ id, name, isActive, paymentIntegrationId }) => (
                <Grid item lg={3} md={4} sm={6} xs={12} key={id}>
                    <LinkWrapper
                        to={!paymentIntegrationId
                            ? { pathname: `${routePaths.customPaymentMethodsSettings}/${id}` }
                            : undefined}
                    >
                        <Card fullHeight>
                            <CardHeader
                                disableTypography
                                title={(
                                    <CardHeaderTitle>
                                        {name}
                                    </CardHeaderTitle>
                                )}
                                subheader={<Typography variant='overline'>{isActive ? t('Active') : t('Disabled')}</Typography>}
                            />
                        </Card>
                    </LinkWrapper>
                </Grid>
            ))}
        </Grid>
    );
};

export default CustomPaymentMethodListView;